module.exports = __webpack_public_path__ + "static/media/van.da94292c.svg";